import React, { useState } from 'react';
import {
  countryOptions,
  extractCountryCode,
  validatePhoneNumber
} from '../../utils/phoneUtils';
import './AddUserModal.css';

const AddUserModal = ({ onClose, onAdd }) => {
  const [name, setName]     = useState('');
  const [countryLabel, setCountryLabel] = useState(countryOptions[0].label);
  const [phone, setPhone]   = useState('');
  const [errors, setErrors] = useState({ name: false, phone: '' });
  const [isActive, setIsActive] = useState(true);

  const phoneErrorMsg = validatePhoneNumber(countryLabel, phone);
  const isPhoneValid = phoneErrorMsg === '' && phone.trim() !== '';

  const handleAddClick = () => {
    let hasError = false;
    const newErrors = { name: false, phone: '' };

    if (!name.trim()) {
      newErrors.name = true;
      hasError = true;
    }
    if (!phone.trim()) {
      newErrors.phone = 'Phone is required';
      hasError = true;
    } else if (phoneErrorMsg) {
      newErrors.phone = phoneErrorMsg;
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    const digits = phone.replace(/\D/g, '');
    const cc     = extractCountryCode(countryLabel);
    const full   = `${cc}${digits}`;
    const status = isActive ? 'active' : 'inactive';

    onAdd(name.trim(), full, status);
    onClose();
  };

  return (
    <div className="add-user-backdrop">
      <div className="add-user-modal">
        <h2>Add User</h2>

        <div className="add-user-input-group">
          <label className="add-user-label">Name</label>
          <input
            type="text"
            placeholder="Enter user name"
            value={name}
            onChange={e => {
              setName(e.target.value);
              setErrors(err => ({ ...err, name: false }));
            }}
            className={`add-user-input ${errors.name ? 'error' : ''}`}
          />
          {errors.name && (
            <div className="error-message">Name is required</div>
          )}
        </div>

        <div className="add-user-input-group">
          <label className="add-user-label">Country/Region</label>
          <select
            className="add-user-input"
            value={countryLabel}
            onChange={e => setCountryLabel(e.target.value)}
          >
            {countryOptions.map(o => (
              <option key={o.code + o.label} value={o.label}>
                {o.label}
              </option>
            ))}
          </select>
        </div>

        <div className="add-user-input-group">
          <label className="add-user-label">Phone</label>
          <input
            type="tel"
            placeholder={`Enter ${countryOptions.find(o => o.label === countryLabel).length} digits`}
            value={phone}
            onChange={e => {
              setPhone(e.target.value);
              setErrors(err => ({ ...err, phone: '' }));
            }}
            className={`add-user-input ${errors.phone ? 'error' : ''}`}
          />
          {errors.phone && (
            <div className="error-message">{errors.phone}</div>
          )}
        </div>

        <div className="add-user-input-group">
          <label className="add-user-checkbox-label">
            <input
              type="checkbox"
              checked={isActive}
              onChange={e => setIsActive(e.target.checked)}
              className="add-user-checkbox"
            />
            Active
          </label>
        </div>

        <div className="add-user-actions">
          <button onClick={onClose} className="add-user-button">
            Cancel
          </button>
          <button onClick={handleAddClick} className="add-user-button">
            Add User
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;